import React, { useState, useEffect } from "react";
import UserNotifications from "components/UserNotifications";
import UserInvites from "components/UserInvites";
import AuthService from "services/AuthService";
import { getTokens, onMessageListener } from "services/FirebaseService";
import { useGlobalContext } from "store/contexts/globalContext";
import { useLocation } from "react-router-dom";
import GlobalSearch from "components/GlobalSearch";
import { useToasts } from "react-toast-notifications";

export default ({ team }) => {
  const [newInvitation, setNewInvitation] = useState(false);
  const [newInvitationData, setNewInvitationData] = useState(null);
  const [newNotification, setNewNotification] = useState(false);
  const [newNotificationData, setNewNotificationData] = useState(null);
  const { addToast } = useToasts();
  const {
    setAiAvatar,
    aiAvatarData,
    setPollNotification,
    ringCentral,
    setZoomToken,
    setRingCentralToken,
  } = useGlobalContext();
  const location = useLocation();
  const routeNameArray = location.pathname.split("/");

  const handlePushNotification = (data) => {

    if (data.data.type === "update.user.points") {
      return;
    }
    
    addToast(data.data?.message, { appearance: "info" });

    if (data.data.type === "user.ringcentral.access_token.generated") {
      setRingCentralToken(data.data);
    }

    if (data.data.type === "user.zoom.access_token.generated") {
      setZoomToken(data.data);
    }

    if (data.data.type === "team.invitation") {
      setNewInvitationData(data.data);
      setNewInvitation(true);
      return;
    }

    if (
      data?.data?.type === "team.poll.closed" ||
      data?.data?.type === "team.poll.responded" ||
      data?.data?.type === "team.poll.created"
    ) {
      setPollNotification({
        pollId: data?.data?.poll_id,
        teamId: data?.data?.team_id,
        type: data?.data?.type,
      });
    }

    if (team !== null && team?.id === data.data.team_id) {
      setNewNotificationData(data);
      // setNewNotification(true);
      return;
    }

    if (team === null) {
      setNewNotificationData(data);
      setNewNotification(true);
      return;
    }
  };

  useEffect(() => {
    try {
      (async () => {
        getTokens()
          .then((payload) => {
            (async () => {
              console.log(payload);
              await AuthService.postPushNoticiationToken(payload);
            })();
          })
          .catch((err) => console.log(err));
      })();
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    const handleMessage = (payload) => {
      if (payload.data.backgroundData) {
        console.log(payload.data.backgroundData);
        if (payload.data.backgroundData.team_id !== team?.id) return;
        handlePushNotification(payload.data.backgroundData);
      }
    };

    navigator.serviceWorker.addEventListener("message", handleMessage);

    return () => {
      navigator.serviceWorker.removeEventListener("message", handleMessage);
    };

    //eslint-disable-next-line
  }, []);

  onMessageListener()
    .then((payload) => {
      console.log(payload);
      if (payload.data.talkingface_processing_id === aiAvatarData.id) {
        setAiAvatar({ id: aiAvatarData.id, data: payload.data });
        return;
      }
      handlePushNotification(payload);
    })
    .catch((err) => console.log("failed: ", err));

  return (
    <>
      {!["un-authorize", "search"].includes(
        routeNameArray[routeNameArray.length - 1]
      ) &&
        !ringCentral && <GlobalSearch team={team} />}
      {routeNameArray[routeNameArray.length - 1] !== "un-authorize" &&
        !ringCentral && (
          <UserNotifications
            team={team}
            newNotification={newNotification}
            setNewNotification={setNewNotification}
            newNotificationData={newNotificationData}
          />
        )}
      <UserInvites
        setNewInvitation={setNewInvitation}
        newInvitation={newInvitation}
        newInvitationData={newInvitationData}
      />
    </>
  );
};
